module.exports = __webpack_public_path__ + "static/media/icon-mail.e25ee04c.svg";